import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { gapi, errMsg, fmtDateTime } from "../api";
import { Panel, Badge } from "./ui";

export default function TaskWidget() {
  const [items, setItems] = useState(null);
  const load = useCallback(() => gapi.get("/tasks", { params: { stato: "aperte", mie: "1" } }).then((r) => setItems(r.data)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  const done = async (t) => {
    const esito = window.prompt("Esito (facoltativo)", "") ?? null;
    if (esito === null) return;
    try { await gapi.patch(`/tasks/${t.id}`, { stato: "completata", esito }); toast.success("Attività completata"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Panel title="Le mie attività da fare" testid="g-dash-tasks">
      {!items ? <p className="text-sm">Caricamento…</p> : !items.length ? <p className="text-sm text-anthracite/45">Nessuna attività aperta.</p> : (
        <ul className="divide-y divide-border-subtle">
          {items.slice(0, 12).map((t) => (
            <li key={t.id} className="py-2.5 flex items-start gap-3" data-testid="g-task-item">
              <button onClick={() => done(t)} className="mt-0.5 grid place-items-center h-6 w-6 rounded-full border border-border-subtle hover:bg-emerald-50 shrink-0" aria-label="Completa" data-testid="g-task-complete"><Check className="h-3.5 w-3.5 text-emerald-700" /></button>
              <div className="flex-1 min-w-0 text-sm">
                <p className="font-medium">{t.titolo}</p>
                <p className="text-xs text-anthracite/50">{t.contactId && <Link to={`/gestionale/contatti/${t.contactId}`} className="text-brand">{t.contattoNome}</Link>} · scadenza {fmtDateTime(t.scadenza)}</p>
              </div>
              {t.scaduta ? <Badge tone="red">scaduta</Badge> : t.priorita === "alta" ? <Badge tone="amber">alta</Badge> : null}
            </li>
          ))}
        </ul>
      )}
      <p className="text-[11px] text-anthracite/40 mt-3">Agenda e gestione completa delle attività arrivano con la Fase 3.</p>
    </Panel>
  );
}
